import React from 'react';
import classNames from 'classnames';
import { FiCheck } from 'react-icons/fi';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './DaySelector.module.scss';

export const DaySelectorComponent = ({
  days = [],
  selectedKeys = [],
  onChange,
  className,
}) => {
  const isSelected = (key) => selectedKeys.includes(key);

  return (
    <div className={classNames(styles.grid, className)}>
      {days.map((day) => {
        const selected = isSelected(day.key);
        return (
          <button
            key={day.key}
            type="button"
            className={classNames(styles.day, {
              [styles.day_active]: selected,
            })}
            onClick={() => onChange?.(day.key)}
          >
            <span
              className={classNames(styles.indicator, {
                [styles.indicator_active]: selected,
              })}
            >
              {selected && <FiCheck size={12} />}
            </span>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Semibold}
              className={styles.short}
            >
              {day.short}
            </Text>
            <Text
              variant={textVariantsEnum.Text_xs}
              fontWeight={fontWeightEnum.Normal}
              color="gray-500"
            >
              {day.long}
            </Text>
          </button>
        );
      })}
    </div>
  );
};

DaySelectorComponent.displayName = 'DaySelector';
